import * as React from 'react';

import { IImageProperties } from '@helpers/utils';

import { MainImg } from './styled';

interface IMainImageProps {
  imageAttrs: IImageProperties;
  onClick: () => void;
}

export const MainImage: React.FC<IMainImageProps> = ({
  imageAttrs,
  onClick,
}) => {
  return <MainImg {...imageAttrs} onClick={onClick} id="pd-image-main" />;
};
